var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loader"},[_vm._v("Loading...")]):_vm._e(),(!_vm.loading && _vm.showGraph)?_c('vue-mermaid',{attrs:{"nodes":_vm.flowchartData,"type":"graph TD","config":_vm.config}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }